import dynamic from 'next/dynamic';

/**
 * This dynamically imports `DynamicSignUpForm` content at the lazily when required.
 * This helps prevent nextjs hydration errors.
 */
export const DynamicSignUpForm = dynamic(() => import('./SignUpForm'), {
  ssr: false,
});
